import {getService,postBodyService} from "./base.service";
import config from "../config/application";

//url
const list = 'country/list';
const add = 'country/add';
const update = 'country/update';
const deleteUrl = 'country/delete';

class CountryService {
    getCountries(user,isPermitted) {
        const url = `${config.data.configuration.country.url}${list}/${user}/${isPermitted}`;
        return getService(url);
    }
    saveCountry(country){
        const url = `${config.data.configuration.country.url}${add}`;
        return postBodyService(url,country);
    }
    updateCountry(country){
        const url = `${config.data.configuration.country.url}${update}`;
        return postBodyService(url,country);
    }
    deleteCountry(lsCountries){
        const url = `${config.data.configuration.country.url}${deleteUrl}`;
        return postBodyService(url,lsCountries);
    }
    
}
export default new CountryService(); 